import {Component} from '@angular/core';

@Component({
  selector: 'mc-drawer-card',
  templateUrl: './drawer-card.component.html',
  styleUrls: ['./drawer-card.component.scss'],
})
export class DrawerCardComponent {}
